import { withRequiredPermissions } from '@/lib/permissions'
import { GuidedDocumentTypeSchema } from '@eigtech/documator-types'
import { ensureClaimCorn } from '@eigtech/shared-corn-helper'
import { GuidedDocumentFlow } from '@eigtech/ui-shared-documator-web'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/generate-document_/guided/$guidedDocumentType'
)({
  component: () => <Component />,
  params: z.object({
    guidedDocumentType: GuidedDocumentTypeSchema,
  }),
})

function RouteComponent() {
  const { claimNumber, guidedDocumentType } = Route.useParams()

  return (
    <GuidedDocumentFlow
      entityId={ensureClaimCorn(claimNumber)}
      guidedDocumentType={guidedDocumentType}
    />
  )
}

const Component = withRequiredPermissions(RouteComponent, {
  requiredPermissions: [{ action: 'create', subject: 'draftDocument' }],
})
